import React, { useState, useRef } from "react";
import "../Home/Home.css";
import Programs from "../ProgramComp/Programs";
import teacher from "../../assets/teacher.png";
import medal from "../../assets/medal.png";
import building from "../../assets/building.png";
import airplane from "../../assets/airplane.png";
import dataScience from "../../assets/DataScienceIma.png"
import leftgirl from "../../assets/Hruthi AI Tech Hub Banner students in Frame.svg";
import book1 from "../../assets/book1.png";
import online from "../../assets/Online&OfflineIcon.png";
// import online from "../../assets/OnlineClass.svg";
import { PiCertificateThin } from "react-icons/pi";
import { RiPresentationFill } from "react-icons/ri";
import contact from "../../assets/Customer.jpg";
import mentors from "../../assets/Mentors.png"
import { BsPersonWorkspace } from "react-icons/bs"; // Example icon for online-offline mode
import { LuCalendarClock } from "react-icons/lu";
import left from "../../assets/left.png";
import right from "../../assets/right.png";
import list from "../../assets/list.png";
import rightgirl from "../../assets/8.png";
import bookimage from "../../assets/book.png";
import musicimage from "../../assets/music-play.png";
import peopleimage from "../../assets/people.png";
import chartimage from "../../assets/chart-2.png";
import girlwithlaptop from "../../assets/Website Images.png";
import girlboygirl from "../../assets/girlboygirl.png";
import { Carousel } from 'react-bootstrap';
import iiit from "../../assets/1.png";
import trusted from "../../assets/WebsitePlacement.png"
import course from "../../assets/2.png";
import deakin from "../../assets/3.png";
import firstgirlimage from "../../assets/firstgirlimage.png";
import secondgirlimage from "../../assets/secondgirlimage.png";
import firstboyimage from "../../assets/firstboyimage.png";
import secondboyimage from "../../assets/secondboyimage.png";
import JM from "../../assets/JM.png";
import C3 from "../../assets/C3.png";
import { IoCall } from "react-icons/io5";
import line from "../../assets/line.png";
import amazon from "../../assets/logos/Amazon-Logo-1024x426-1.webp";
import coca from "../../assets/logos/Coca-Cola_logo.svg.png"
import dell from "../../assets/logos/Dell_Logo.png"
import deloitte from "../../assets/logos/Deloitte_Logo.png"
import hgs from "../../assets/logos/HGS_logo.jpg"
import ibm from "../../assets/logos/IBM Logo.jpg"
import intel from "../../assets/logos/intel_logo.jpg"
import lt from "../../assets/logos/L&T logo.png"
import logo from "../../assets/logos/microsoft_logo.png"
import microsoft from "../../assets/logos/microsoft_logo.png"
import tata from "../../assets/logos/Tata Logo.jpg"
import uber from "../../assets/logos/Uber Logo.png"
import well from "../../assets/logos/Wellsforgo Logo.png"
import wipro from "../../assets/logos/Wipro_Logo.png"
import yash from "../../assets/logos/YASH_Technologies_Logo.jpg"
import manhandsfold from "../../assets/manhandsfold.png";
import leftrightarrow from "../../assets/leftrightarrow.png";
import rightcircle from "../../assets/rightcircle.png";
import rightarrow from "../../assets/rightarrow.png";
import leftcircle from "../../assets/leftcircle.png";
import leftarrow from "../../assets/leftarrow.png";
import trainingboy from "../../assets/WebWomen.png";
import studygirl from "../../assets/WebStundetsitting.png";
import demand from "../../assets/cbdemandicon.png";
import doubt from "../../assets/cbdoubticon.png";
import project from "../../assets/cbprojecticon.png";
import skills from "../../assets/cbskillicon.png";
import resume from "../../assets/cbresumeicon.png";
import interview from "../../assets/cbinterviewicon.png";
import company1 from "../../assets/company1.png";
import company2 from "../../assets/company2.png";
import company3 from "../../assets/company3.png";
import company4 from "../../assets/company4.png";
import company5 from "../../assets/company5.png";
import company6 from "../../assets/company6.png";
import company7 from "../../assets/company7.png";
import company8 from "../../assets/company8.png";
import company9 from "../../assets/company9.png";
import company10 from "../../assets/company10.png";
import company11 from "../../assets/company11.png";
import company12 from "../../assets/company12.png";
import company13 from "../../assets/company13.png";
import company14 from "../../assets/company14.png";
import company15 from "../../assets/company15.png";
import company16 from "../../assets/company16.png";
import company17 from "../../assets/company17.png";
import company18 from "../../assets/company18.png";
import company19 from "../../assets/company19.png";
import company20 from "../../assets/company20.png";
import newrightgirl from "../../assets/newrightgirl.png";
import testimonialpic1 from "../../assets/testimonialpic1.png";
import lscu from "../../assets/contactus.png";
import india from "../../assets/india.png";
import world from "../../assets/world.png";
import genz from "../../assets/genai&chatgpt.png";
import courselogo from "../../assets/brifecase-cross.png";
import manone from "../../assets/manone.png";
import mantwo from "../../assets/mantwo.png";
import manthree from "../../assets/manthree.png";
import manfour from "../../assets/manfour.png";
import manfive from "../../assets/manfive.png";
import mansix from "../../assets/mansix.png";
import medalstar from "../../assets/medal-star.png";
import brifecase from "../../assets/brifecase-cross.png";
import calendar2 from "../../assets/calendar-2.png";
import usertick from "../../assets/user-tick.png";
import manseven from "../../assets/manseven.png";
import maneight from "../../assets/maneight.png";
// import mannine from "../../assets/mannine.png";
import curlyarrow from "../../assets/curlyarrow.jpg";
import curlyarrow2 from "../../assets/curlyarrow2.png";
import { FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";

import Thirupathamma from '../../assets/mentorimage19.png';
import Pavan from '../../assets/mentorimage16.png';
import Veranna from '../../assets/mentorimage6.png';
import Vijay from '../../assets/mentorimage24.png';
import Krishna from '../../assets/mentorimage15.JPG';
import Satya from '../../assets/mentorimage10.png';
import Gopi from '../../assets/mentorimage12.png';
import Jyothi from '../../assets/mentorimage3.png';
import Bhargav from '../../assets/mentorimage2.png';
import Simhachalam from '../../assets/mentorimage20.png';
import Srevali from '../../assets/mentorimage21.png';
import Akhil from '../../assets/mentorimage28.png';
import Vinod from '../../assets/mentorimage17.png';
import Leela from '../../assets/mentorimage9.png';
import vasam from "../../assets/placements/Vasam_Arunkumar-removebg-preview.png"
import venkata from "../../assets/placements/_Venkata_Sai_-removebg-preview.png"
import janagam from "../../assets/placements/Jangam_Rajasekhar-removebg-preview.png"
import mahesh from "../../assets/placements/Mahesh_Nandibattini-removebg-preview.png"
import chinna from "../../assets/placements/chaina_ram-removebg-preview.png"
import maheshBon from "../../assets/placements/Mahesh_Bathula-removebg-preview.png"
import mekala from "../../assets/placements/Mr.Mekala_Anil-removebg-preview.png"
import vasmir from "../../assets/placements/Vasimalla_Raja_Sekhar-removebg-preview.png"


import cloudzest from '../../assets/cloudzest.jpg'
import nttdata from '../../assets/ntt data.png'
import cognizant from '../../assets/cognizant.png'
import accenture from '../../assets/Accenture.png'
import Deloitte from '../../assets/deloitte.png'
import techmahindra from '../../assets/TMlogo.png'
import lti from '../../assets/lti.png'
import info from '../../assets/info.jpg'
import prodapt from '../../assets/prodapt.png'
import virtusa from '../../assets/Virtusa.png'
import capgemini from "../../assets/logos/Capgemini Logo.webp"
import walkingtree from '../../assets/walkingtree.png'
import globallogic from '../../assets/globallogic.png'
import statusneo from '../../assets/statusneo.jpg'
import concentrix from '../../assets/Concentrix.png'
import straive from '../../assets/straive.jpg'
import trigent from '../../assets/trigent.png'
import blueyonder from '../../assets/blueyonder.png'
import covalense from '../../assets/covalense.jpg'
import lancesoft from '../../assets/Lancesoft.png'

import cflogo from '../../assets/cflogo.png'
import issquared from '../../assets/issquared.png'
import novitaslogo from '../../assets/novitaslogo.png'
import apxor from '../../assets/apxor.jpg'

import by from "../../assets/logos/images.png"


const courseFeatures = {
  beginnerToPro: {
    // title: "Beginner To Pro In 4 - 8 Months",
    title: "Beginner To Pro In 4 - 8 Months",
    description:
      "With a curriculum designed and taught by industry experts, you will get the skills and mentorship for guaranteed success",
    features: [
      { icon: demand, text: "On-demand classes" },
      { icon: doubt, text: "Live doubt clearing sessions" },
      { icon: project, text: "Industry-level projects" },
    ],
  },
  jobReady: {
    title: "Become Job-Ready",
    description:
      "Prepare to ace your job hunt with our career coaches, who have 10+ years of experience. Say goodbye to job anxiety!",
    features: [
      { icon: skills, text: "Soft skills training" },
      { icon: resume, text: "Cover letter & resume preparation" },
      { icon: interview, text: "Mock interview practice" },
    ],
  },
};

const testimonialData = [
  {
    id: 1,
    beforeRole: "Technical Service Engineer",
    afterRole: "AI Solution Consultant",
    beforeImage: JM,
    afterImage: C3,
    name: "Cameron Williamson",
    course: "EPGP in Data Science from IIITB 2023",
  },
  {
    id: 2,
    beforeRole: "Junior Developer",
    afterRole: "Senior Software Engineer",
    beforeImage: firstboyimage,
    afterImage: secondboyimage,
    name: "Emily Johnson",
    course: "Advanced Software Engineering from MIT 2022",
  },
  {
    id: 3,
    beforeRole: "Data Analyst",
    afterRole: "Data Science Manager",
    beforeImage: firstgirlimage,
    afterImage: secondgirlimage,
    name: "Michael Chen",
    course: "Master's in Big Data Analytics from Stanford 2021",
  },
];


const courseData = [
  {
    id: 1,
    timeperiod: "December 2024",
    students: [
   

      {
        studentName: "Venkata Sai",
        image: venkata,
        previouscompanylogo: cflogo,
        before: "Process Associate",
        after: "Up Skill",
        companyLogo: cloudzest,
      },

      {
        studentName: "Sanneboina Thirupathamma",
        image: Thirupathamma,
        previouscompanylogo: issquared,
        before: "Jr. Assistant",
        after: "Up Skill",
        companyLogo: nttdata,
      },

      {
        studentName: "Vasam Arunkumar",
        image: vasam,
        previouscompanylogo: novitaslogo,
        before: "Executive",
        after: "Up Skill",
        companyLogo: by,
      },
   
     
      {
        studentName: "chaina ram",
        image: chinna,
        previouscompanylogo: apxor,
        before: "System Engineer",
        after: "Up Skill",
        companyLogo: cognizant,
      }
    ]
  },
  {
    id: 2,
    timeperiod: "November 2024",
    students: [

      {
        studentName: "Guguloth  Veeranna",
        image: Veranna,
        previouscompanylogo: issquared,
        before: "Support Engineer",
        after: "Up Skill",
        companyLogo: accenture,
      },  

   
      {
        studentName: "Mr.Mekala Anil",
        image: mekala,
        previouscompanylogo: cflogo,
        before: "Process Associate",
        after: "Up Skill",
        companyLogo: Deloitte,
      },
      {
        studentName: "Vasimalla Raja Sekhar",
        image: vasmir,
        previouscompanylogo: novitaslogo,
        before: "Jr. Assistant",
        after: "Up Skill",
        companyLogo: techmahindra,
      },
      {
        studentName: "Vasundhara vijay bhele",
        image: Vijay,
        previouscompanylogo: apxor,
        before: "Executive",
        after: "Up Skill",
        companyLogo: accenture,
      }
    ]

  },
  {
    id: 3,
    timeperiod: "October 2024",
    students: [

      {
        studentName: "Medlboina Krishna reddy",
        image: Krishna,
        previouscompanylogo: cflogo,
        before: "System Engineer",
        after: "Up Skill",
        companyLogo: lti,
      },

      {
        studentName: "Kopparthi satyavamsi",
        image: Satya,
        previouscompanylogo: issquared,
        before: "Support Engineer",
        after: "Up Skill",
        companyLogo: info,
      },

      {
        studentName: "Kummitha Gopinadh Reddy",
        image: Gopi,
        previouscompanylogo: novitaslogo,
        before: "Process Associate",
        after: "Up Skill",
        companyLogo: prodapt,
      },

      
  
      
     
    ]

  },
  {
    id: 4,
    timeperiod: "September 2024",
    students: [

      {
        studentName: "Burra Jyothi",
        image: Jyothi,
        previouscompanylogo: apxor,
        before: "Jr. Assistant",
        after: "Up Skill",
        companyLogo: virtusa,
      },
      {
        studentName: "Muppidi Pavan kalyan",
        image: Pavan,
        previouscompanylogo: cflogo,
        before: "Executive",
        after: "Up Skill",
        companyLogo: lti,
      },

      {
        studentName: "Akuthota Bhargav Lakshman",
        image: Bhargav,
        previouscompanylogo: issquared,
        before: "System Engineer",
        after: "Up Skill",
        companyLogo: capgemini,
      },

    
    ]
  },
  {
    id: 5,
    timeperiod: "August 2024",
    students: [
     
      {
        studentName: "Simhanchalam",
        image: Simhachalam,
        previouscompanylogo: novitaslogo,
        before: "Support Engineer",
        after: "Up Skill",
        companyLogo: walkingtree,
      }, 
      {
        studentName: "Srevali pachi pulusu",
        image: Srevali,
        previouscompanylogo: cflogo,
        before: "Process Associate",
        after: "Up Skill",
        companyLogo: globallogic,
      },
      {
        studentName: "Akhil",
        image: Akhil,
        previouscompanylogo: apxor,
        before: "Jr. Assistant",
        after: "Up Skill",
        companyLogo: statusneo,
      },
      {
        studentName: "Nitta vinod",
        image: Vinod,
        previouscompanylogo: issquared,
        before: "Executive",
        after: "Up Skill",
        companyLogo: concentrix,
      },

    ]

  },
  {
    id: 6,
    timeperiod: "July 2024",
    students: [
      
      {
        studentName: "Mahesh Nandibattini",
        image: mahesh,
        previouscompanylogo: issquared,
        before: "System Engineer",
        after: "Up Skill",
        companyLogo: straive,
      },
      {
        studentName: "Mahesh Bathula",
        image: maheshBon,
        previouscompanylogo: apxor,
        before: "Support Engineer",
        after: "Up Skill",
        companyLogo: accenture,
      },
      {
        studentName: "Kondaveeti Leelachaitanya",
        image: Leela,
        previouscompanylogo: cflogo,
        before: "Executive",
        after: "Up Skill",
        companyLogo: trigent,
      },
      {
        studentName: "Jangam Rajasekhar",
        image: janagam,
        previouscompanylogo: novitaslogo,
        before: "Process Associate",
        after: "Up Skill",
        companyLogo: techmahindra,
      },

     
    ]

  }
];


const programs = [
  {
    imgSrc: iiit,
    title: "Cyber Security SOC With AI",
    path: "/programs/cybersecurity",
    certificates: [
      { text: "8 Months", icon: <LuCalendarClock style={{ width: "30px", height: "30px" }} /> },
      { text: "Online-Offline", icon: <RiPresentationFill style={{ width: "30px", height: "30px" }} /> },
      { text: "100% Job Guarantee No Code", icon: <PiCertificateThin style={{ width: "30px", height: "30px" }} /> },
    ],
  },
  {
    imgSrc: course,
    title: "Full Stack (MERN) SDE with AI",
    path: "/programs/fullstack",
    certificates: [
      { text: "9 Months", icon: <LuCalendarClock style={{ width: "30px", height: "30px" }} /> },
      { text: "Online-Offline", icon: <RiPresentationFill style={{ width: "30px", height: "30px" }} /> },
      { text: "100% Job Guarantee Full Code", icon: <PiCertificateThin style={{ width: "30px", height: "30px" }} /> },
    ],
  },
  {
    imgSrc: deakin,
    title: "Data Analyst with AI",
    path: "/programs/data-analytics",
    certificates: [
      { text: "8 Months", icon: <LuCalendarClock style={{ width: "30px", height: "30px" }} /> },
      { text: "Online-Offline", icon: <RiPresentationFill style={{ width: "30px", height: "30px" }} /> },
      { text: "100% Job Guarantee No Code", icon: <PiCertificateThin style={{ width: "30px", height: "30px" }} /> },
    ],
  },
  {
    imgSrc: dataScience,
    title: "Data Science with AI & ML",
    path: "/programs/data-science",
    certificates: [
      { text: "8 Months", icon: <LuCalendarClock style={{ width: "30px", height: "30px" }} /> },
      { text: "Online-Offline", icon: <RiPresentationFill style={{ width: "30px", height: "30px" }} /> },
      { text: "100% Job Guarantee No Code", icon: <PiCertificateThin style={{ width: "30px", height: "30px" }} /> },
    ],
  },
];


const Home = () => {
  const [activeCategory, setActiveCategory] = useState("lowCode");
  const [activeProfessionalCategory, setActiveProfessionalCategory] =
    useState("category1");
  const [selectedComponent, setSelectedComponent] = useState("");
  const [activeCourse, setActiveCourse] = useState(2);

  const handleCourseClick = (courseId) => {
    setActiveCourse(courseId);
  };

  const currentCourse = courseData.find(course => course.id === activeCourse);

  const scrollToComponent = () => {
    // if (selectedComponent) {
    const target = document.getElementById("programsSection");
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
    // }
  };

  const handleViewProgram = (path) => {
    navigate(path);
  };

  const programs = {
    lowCode: [
      {
        img: manone,
        title: "Data Analytics with AI Automation",
        path: "/fullstack",
        details: [
          { icon: medalstar, text: "Certificate" },
          { icon: brifecase, text: "100% Job Graduate Program" },
          { icon: calendar2, text: "8 months" },
          { icon: usertick, text: "3 month internship" },
        ],
      },
      {
        img: manone,
        title: "Cyber Security Expert with AI",
        path: "/fullstack",
        details: [
          { icon: medalstar, text: "Certificate" },
          { icon: brifecase, text: "100% Job Graduate Program" },
          { icon: calendar2, text: "8 months" },
          { icon: usertick, text: "3 month internship" },
        ],
      },
    ],
    code: [
      {
        img: manthree,
        title: "FullStack ReactJs with AI",
        path: "/fullstack",
        details: [
          { icon: medalstar, text: "Certificate" },
          { icon: brifecase, text: "100% Job Graduate Program" },
          { icon: usertick, text: "3 month internship" },
        ],
      },
      {
        img: manone,
        title: "Data Science with AI & ML",
        path: "/fullstack",
        details: [
          { icon: medalstar, text: "Certificate" },
          { icon: brifecase, text: "100% Job Graduate Program" },
          { icon: calendar2, text: "8 months" },
          { icon: usertick, text: "3 month internship" },
        ],
      },
    ],
  };

  const professionalPrograms = {
    category1: [
      {
        img: manseven,
        title: "Data Analytics with AI Automation",
        path: "/fullstack",
        details: [
          { icon: medalstar, text: "Certificate" },
          { icon: calendar2, text: "8 months" },
        ],
      },
      {
        img: manseven,
        title: "Cyber Security Expert with AI",
        path: "/fullstack",
        details: [
          { icon: medalstar, text: "Certificate" },
          { icon: calendar2, text: "8 months" },
        ],
      },

    ],
    category2: [
      {
        img: maneight,
        title: "FullStack ReactJs with AI",
        path: "/fullstack",
        details: [
          { icon: medalstar, text: "Certificate" },
          { icon: calendar2, text: "8 months" },
        ],
      },
      {
        img: manseven,
        title: "Data Science with AI & ML",
        path: "/fullstack",
        details: [
          { icon: medalstar, text: "Certificate" },
          { icon: calendar2, text: "8 months" },
        ],
      },
    ],
    category3: [
      {
        img: maneight,
        title: "FullStack ReactJs AI Expert",
        path: "/fullstack",
        details: [
          { icon: medalstar, text: "Certificate" },
          { icon: calendar2, text: "8 months" },
        ],
      },
      {
        img: manseven,
        title: "Cyber Security SOC AI Expert",
        path: "/fullstack",
        details: [
          { icon: medalstar, text: "Certificate" },
          { icon: calendar2, text: "8 months" },
        ],
      },
    ],
  };


  const images = [
    "https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/1.png",
    "https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/2.png",
    "https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/3.png",
    "https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/4.png",
    "https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/5.png",
    "https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/6.png",
    "https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/7.png",
  ];


  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState("learning");
  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);


  const handleNextTestimonial = () => {
    setCurrentTestimonialIndex(
      (prevIndex) => (prevIndex + 1) % testimonialData.length
    );
  };

  const handlePrevTestimonial = () => {
    setCurrentTestimonialIndex(
      (prevIndex) =>
        (prevIndex - 1 + testimonialData.length) % testimonialData.length
    );
  };

  const currentTestimonial = testimonialData[currentTestimonialIndex];

  // Dummy data for Learning and Placement
  const learningData = [
    { id: 1, text: "Live Interactive Classes" },
    { id: 2, text: "AI-Powered Doubt Resolution" },
    { id: 3, text: "Extensive Live Doubt Support" },
    // { id: 4, text: "Weekly Project Evaluation" },
    // { id: 4, text: "Weekly Project Evaluation" },
    { id: 5, text: "Enterprise Project Coding Labs" },
  ];

  const placementData = [
    { id: 1, text: "Focused HR & Technical Interview Sessions" },
    { id: 2, text: "Comprehensive Resume Building Workshops" },
    { id: 3, text: "Lifetime Access to Interview Preparation Recordings" },
    { id: 4, text: "Exclusive Access to Our Placement Portal" },
  ];


  const sectionHeadings = {
    learning: "Unlock Your Potential with Project-Based Upskilling",
    learning: "Unlock Your Potential with Project-Based Upskilling",
    placement: "Personalized Roadmap to Guaranteed Job Success",
  };


  const renderData =
    selectedOption === "learning" ? learningData : placementData;

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Handle left arrow click
  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };
 
  const companyLogos = [
    cognizant,
    lancesoft,
    accenture,
    techmahindra,
    covalense,
    info,
    capgemini,
    lti,
    deloitte,
    blueyonder,
    concentrix,
    nttdata,
    statusneo
  ];

  const companyLogos1 = [
    amazon,
    coca,
    dell,
    deloitte,
    hgs,
    ibm,
    intel,
    lt,
    microsoft,
    tata,
    uber,
    well,
    wipro,
    yash
  ]

  const testimonials = [
    {
      id: 1,
      image: testimonialpic1,
      text: "We hired rockstar developers from Hruthi AI Tech Hub!",
      detail: "We had a great experience while hiring software developers...",
    },
    {
      id: 2,
      image: testimonialpic1,
      text: "Fantastic hiring process!",
      detail: "The candidates are truly prepared with sound fundamentals...",
    },
    {
      id: 3,
      image: testimonialpic1,
      text: "Highly recommend Hruthi AI Tech Hub.",
      detail: "We've successfully onboarded amazing engineers through them...",
    },
  ];

  const navigate = useNavigate();


  return (
    <div>
      <div className="body-part1">
        <div className="hm1-middle-body">
          <img
            src={leftgirl}
            alt="Left Girl"
            className="hm1-middle-body-img left-img"
          />
          <div className="hm1-data">
            <h1 style={{ marginBottom: "20px" }}>

              Upskill with <span style={{ color: "#ff3131", fontWeight: "bold" }}>AI-POWERED</span> <br />
              Skills for every{" "}

              <span style={{ fontWeight: "bold", color: "#ff3131" }}>JOB ROLE</span>
            </h1>
            <p className="Upskill">
              Master Tomorrow’s <span style={{ color: "#ff3131" }}>AI-driven Skills</span> <br />
              with India’s premier<span style={{ color: "#ff3131" }}> Upskilling </span>
              platform
            </p>
          </div>
          <img
            src={rightgirl}
            alt="Right Girl"
            className="hm1-middle-body-img right-img"
          />
        </div>

        <div className="upskill-body">
          <div className="all-inputs">
            <button className="explore-btn" onClick={scrollToComponent}>
              Explore Courses
            </button>
          </div>
        </div>
      </div>
    
    <div
        className="container py-4"
        style={{ backgroundColor: "#f4f6fc", borderRadius: "16px" }}
      >
        <h2 className="text-center mb-4" style={{ fontFamily: "Gotham, sans-serif", fontWeight: "bold" }}>
          Upskill with <span style={{ color: "#ff3131" }}>AI-Driven </span> Skills & Get Hired from
          <span style={{ color: "#ff3131" }}> 750+ Client Partners</span>
        </h2>

        {/* Second Carousel (Reverse Direction) */}
        <div className="slider reverse">
          <div className="slide-track">
            {images.concat(images).map((image, index) => (
              <div className="slide" key={index}>
                <img
                  src={image}
                  style={{ padding: "5px", borderRadius: "5px" }}
                  height="100"
                  width="250"
                  alt={`Slide ${index + 1}`}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div>

        <div className="part4-body">
          <img src={girlwithlaptop} alt="" className="girl-with-laptop" />
          <div>
            <div className="mobile-learn">
              <div className="learn-buttons">
                <button
                  className={`learning-btn ${selectedOption === "learning" ? "active" : ""
                    }`}
                  onClick={() => setSelectedOption("learning")}
                >
                  Learning
                </button>
                <button
                  className={`placement-btn ${selectedOption === "placement" ? "active" : ""
                    }`}
                  onClick={() => setSelectedOption("placement")}
                >
                  Placement
                </button>
              </div>
            </div>
            <div className="step-text-body">
              <p>{sectionHeadings[selectedOption]}</p>
            </div>
            <p className="best-text">
              {/* Best {selectedOption} and placement support for your career */}
              Upskilling with Project-Based Learning with 100% Personalized Placement
            </p>
            <div className="checkbox-body-1">
              {renderData.map((item) => (
                <div key={item.id} className="check-home">
                  <FaCheckCircle />
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}


      <div className="aage-body" id="programsSection">
        <div className="aage-body" id="programsSection">
          <div>
            <p className="aage-text">Get Upskill with AI & Get Transformed - 100% Job Guarantee Program*</p>
          </div>
          <div>
            <p className="discover-text">
              Advance with Confidence with 8-month Job Guarantee Program Powered by AI
            </p>
          </div>

          <div className="course-container">
            {[
              {
                imgSrc: iiit,
                title: "Cyber Security SOC With AI",
                path: "/programs/cybersecurity",
                certificates: [
                  { text: "8 Months", icon: <LuCalendarClock style={{ width: "30px", height: "30px" }} /> },
                  { text: "Online-Offline", icon: <RiPresentationFill style={{ width: "30px", height: "30px" }} /> },
                  { text: "100% Job Guarantee No Code", icon: <PiCertificateThin style={{ width: "30px", height: "30px" }} /> },
                ],
              },
              {
                imgSrc: course,
                title: "Full Stack (MERN) SDE with AI",
                path: "/programs/fullstack",
                certificates: [
                  { text: "9 Months", icon: <LuCalendarClock style={{ width: "30px", height: "30px" }} /> },
                  { text: "Online-Offline", icon: <RiPresentationFill style={{ width: "30px", height: "30px" }} /> },
                  { text: "100% Job Guarantee Full Code", icon: <PiCertificateThin style={{ width: "30px", height: "30px" }} /> },
                ],
              },
              {
                imgSrc: deakin,
                title: "Data Analyst with AI",
                path: "/programs/data-analytics",
                certificates: [
                  { text: "8 Months", icon: <LuCalendarClock style={{ width: "30px", height: "30px" }} /> },
                  { text: "Online-Offline", icon: <RiPresentationFill style={{ width: "30px", height: "30px" }} /> },
                  { text: "100% Job Guarantee No Code", icon: <PiCertificateThin style={{ width: "30px", height: "30px" }} /> },
                ],
              },
              {
                imgSrc: dataScience,
                title: "Data Science with AI & ML",
                path: "/programs/data-science",
                certificates: [
                  { text: "8 Months", icon: <LuCalendarClock style={{ width: "30px", height: "30px" }} /> },
                  { text: "Online-Offline", icon: <RiPresentationFill style={{ width: "30px", height: "30px" }} /> },
                  { text: "100% Job Guarantee No Code", icon: <PiCertificateThin style={{ width: "30px", height: "30px" }} /> },
                ],
              },
            ].map((program, index) => (
              <div className="program-card" key={index}>
                <img src={program.imgSrc} alt={program.title} className="program-card-image" />
                <h3 className="program-card-title">{program.title}</h3>
                <div className="program-card-certificates">
                  {program.certificates.map((cert, certIndex) => (
                    <div key={certIndex} className="certificate-item">
                      {cert.icon}
                      <span className="certificate-text">{cert.text}</span>
                    </div>
                  ))}
                </div>
                <button
                  className="program-card-button"
                  onClick={() => navigate(program.path)}
                >
                  View Program
                </button>
              </div>
            ))}
          </div>






        </div>

        <div className="mentors-container">
          <div className="mentors-text">
            <h1 className="mentorHeading">Meet the Mentors Shaping Your Future</h1>
            <h1 className="mentorsPara">Lead you towards Mastery & <span style={{ color: "#ff3131" }}>Professional Job </span>Growth Opportunities</h1>
          </div>
          <div className="mentors-image-container">
            <img src={mentors} alt="Mentors" className="mentorsImg" />
          </div>
        </div>

        <>
          <div className="curriculum-container">
            <p className="curriculum-header">Placement Highlights</p>
            <h1 className="curriculum-title">No Matter Your Career Background <span style={{ color: "#ff3131" }}>Step Into the Future Dream Jobs with Us !</span></h1>

            <div className="curriculum-courses-navigation">
              {courseData.map((course) => (
                <button
                  key={course.id}
                  className={`placements-course-button ${activeCourse === course.id ? "active" : ""}`}
                  onClick={() => handleCourseClick(course.id)}
                >
                  {course.timeperiod}
                </button>
              ))}
            </div>

            <div className="student-cards-container">
              {currentCourse.students.map((student, index) => (
                <div key={index} className="profile-card">
                  <div className="profile-header">
                    <img src={student.image} alt={student.studentName} className="profile-pic" />
                    <div className="profile-name">{student.studentName}</div>
                    <a href="#" className="linkedin-icon">in</a>
                  </div>
                  <div className="profile-content">
                    <div className="profile-before">
                      <h3>Before</h3>
                      <img src={student.previouscompanylogo} alt="cflogo" />
                      <p>{student.before}</p>
                      
                    </div>
                    <div className="profile-after">
                      <h3>After</h3>
                      <div className="place-after">
                        <p>
                          <strong>{student.after}</strong>
                        </p>
                        <img src={student.companyLogo} alt="Company Logo" />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>


                     </div>
        </>

        <div className="courses-best-container">
          {/* <h2>{courseFeatures.beginnerToPro.title}</h2> */}
          <div className="courses-best-container1">

            <div className="left-section">
              <h2>Beginner To Pro In <span style={{ color: "#ff3131" }}>4-8 Months</span></h2>
              <p>{courseFeatures.beginnerToPro.description}</p>
              <ul className="features-list">
                {courseFeatures.beginnerToPro.features.map((feature, index) => (
                  <li key={index}>
                    <span className="icon">
                      <img src={feature.icon} alt="feature-icon" />
                    </span>
                    <div className="cbopt">{feature.text}</div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="image-section">
              <img src={studygirl} alt="Study Woman" className="study-image" />
            </div>
          </div>
          <div className="job-ready-section">

            <div className="image-section">
              <img
                src={trainingboy}
                alt="Student Training"
                className="training-image"
              />

            </div>

            <div className="right-section">
              <h2>{courseFeatures.jobReady.title}</h2>
              <p>{courseFeatures.jobReady.description}</p>
              <ul className="features-list">
                {courseFeatures.jobReady.features.map((feature, index) => (
                  <li key={index}>
                    <span className="icon">
                      <img src={feature.icon} alt="feature-icon" />
                    </span>
                    <div className="cbopt">{feature.text}</div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="hirrecompanyfull">
          <h1><span style={{ color: "#ff3131" }}> 750+ Companies</span>-Hire From Us !</h1>
          <p>Check out why our hiring partner trusts us</p>
          <div className="hire-company-container">

            <div className="company-logos">
              {companyLogos.map((logo, index) => (
                <img
                  key={index}
                  src={logo}
                  alt={`Logo ${index + 1}`}
                  className="logo"
                />
              ))}
            </div>
            <div className="trusted-section">
              <img className="trusted-img" src={trusted} alt="Trusted" />
            </div>
          </div>
        </div>

        {/* <div className="support-container">

        
        </div> */}

        <div className="content">

       

          <div className="contact-section">
            <div className="contact-content">
              <h4 className="contact-title">Got more questions?</h4>
              <h2 className="contact-subtitle">Talk to our team directly</h2>
              <p className="contact-text">
                Contact us and our academic counsellor will get in touch with you shortly
              </p>
              <div className="contact-buttons">
                <button className="enquire-button">ENQUIRE NOW</button>
                <button className="phone-button">
                  <span className="phone-icon"><IoCall /></span>
                  <span className="phone-number">+9189775 17381</span>
                </button>
              </div>
            </div>
            <div className="contact-image">
              <img
                src={contact}
                alt="Contact Team"
                className="contact-img"
              />
            </div>
          </div>
        </div>
      </div>

    </div >
  );
};

export default Home;
